import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";

import image1 from "assets/images/Multiple/IMC-manush1.jpg";
import image2 from "assets/images/Multiple/image-imc.jpg";
import image3 from "assets/images/Multiple/shubh1.jpg";
import image4 from "assets/images/studs/tanay2.jpg";
import image5 from "assets/images/Multiple/offline-image.jpg";
import image6 from "assets/images/Multiple/Hanya1.jpg";
import MKButton from "components/MKButton";
import { Icon } from "@mui/material";
import { useNavigate } from "react-router-dom";

function WhyUs() {
    const navigate = useNavigate();
    return (
        <MKBox
            component="section"
            variant="gradient"
            bgColor="info"
            position="relative"
            py={6}
            px={{ xs: 2, lg: 0 }}
            mx={-2}
        >
            <Container>
                <Grid container>
                    <Grid item xs={12} md={8} sx={{ mb: 6 }}>
                        <MKTypography variant="h3" color="white">
                            We are your Global Chess Hub, Epitome of IM Chess.
                        </MKTypography>
                        <MKTypography variant="body2" color="white" opacity={0.8}>
                            IM Chess is for All
                        </MKTypography>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <MKButton variant="gradient"
                            onClick={() => navigate('/imchess-info')}
                            color="light" sx={{
                                width: "max-content",
                                display: "flex",
                                alignItems: "center",
                                marginBottom: '25px',

                                "& .material-icons-round": {
                                    transform: `translateX(3px)`,
                                    transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
                                },

                                "&:hover .material-icons-round, &:focus .material-icons-round": {
                                    transform: `translateX(6px)`,
                                },
                            }}>
                            Discover More Perks <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
                        </MKButton>
                    </Grid>
                </Grid>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={6}>
                        <MKBox mb={1}>
                            <HorizontalTeamCard
                                image={image1}
                                name="IM-Led Expert Coaching"
                                position={{ color: "info", label: "IM Manush Shah" }}
                                description="Learn directly from IM Manush Shah, with 22+ years of playing experience and 5+ years of proven coaching success and get his expert advise from his IM journey."
                            />
                        </MKBox>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <MKBox mb={1}>
                            <HorizontalTeamCard
                                image={image5}
                                name="Global Student Community"
                                position={{ color: "info", label: "Mode of developing chess skills : Online & Offline" }}
                                description="Our students come from India, USA, and across the world, creating a rich learning environment where talent grows together."
                            />
                        </MKBox>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <MKBox mb={{ xs: 1, lg: 0 }}>
                            <HorizontalTeamCard
                                image={image2}
                                name="Structured & Certified Programs"
                                position={{ color: "info", label: "Step-by-step Beginner to Advanced levels, with:" }}
                                description="Free Assessments, End-of-level exams, Regular feedback, Certified progression"
                            />
                        </MKBox>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <MKBox mb={{ xs: 1, lg: 0 }}>
                            <HorizontalTeamCard
                                image={image3}
                                name="Shubh Atha (11 yrs)"
                                position={{ color: "info", label: "Proven Student Success Stories" }}
                                description="FIDE 1875, Open category winner against higher-rated players."
                            />
                        </MKBox>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <MKBox mb={{ xs: 1, lg: 0 }}>
                            <HorizontalTeamCard
                                image={image4}
                                name="Tanay Sanghani (10 yrs)"
                                position={{ color: "info", label: "Proven Student Success Stories" }}
                                description="USCF 1935, tournament champion in USA."
                            />
                        </MKBox>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <MKBox mb={{ xs: 1, lg: 0 }}>
                            <HorizontalTeamCard
                                image={image6}
                                name="Hanya Shah (12 yrs)"
                                position={{ color: "info", label: "Proven Student Success Stories" }}
                                description="Western Asian U-10 Champion, Elo 1888 (from 1149 in 2 years)."
                            />
                        </MKBox>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default WhyUs;